/**
 * Created by Stefann on 27/03/2019.
 */

export class Comparison {
    constructor(public cheapest: any, public sortedByCheapest: any, public mostComplete: any, public sortedByMostComplete: any, public bestValueForMoney: any, public sortedByBestValueForMoney: any, public branch: any, public period: any) {
    }
}
